import {useLocalesMgr} from 'coreHooks';
import {ESFCCAssetType} from 'coreHooks/useSFCCAsset/ISFCCAsset';
import {useGeneralProvider} from 'brandComponents/_app-config/GeneralProvider';

const SCRIPTS_DETAILS = {
	[ESFCCAssetType.DWAC]: {
		version: '21.7',
		name: 'dwac',
	},
	[ESFCCAssetType.DWANALYTICS]: {
		version: '22.2',
		name: 'dwanalytics',
	},
};

/**
 * Generates legacy SFCC assets URLs.
 * @param {ESFCCAssetType} script - script to generate
 */
export default (script: ESFCCAssetType) => {
	const {managerRepository} = useGeneralProvider();
	const siteID = managerRepository.getSfccAPI().getSiteId();
	const localesMgr = useLocalesMgr();
	const languageCode = localesMgr.getCurrentLanguage().getLanguageCode();
	const currentScript = SCRIPTS_DETAILS[script];

	if (!currentScript) {
		throw new Error(`The script: "${script}" doesn't exist`);
	}

	return `/on/demandware.static/Sites-${siteID}-Site/-/${languageCode}/v1762575999871/internal/jscript/${currentScript.name}-${currentScript.version}.js`;
};
